// import React, { useContext } from "react";
// import { useState, useEffect } from "react";
// import "../../Tabels/Tabels.css";
// import plus from "../../../Components/assets/icons/a1.png";
// import colunms from "../../../Components/assets/icons/LINES.png";
// import pen from "../../../Components/assets/icons/pen.png";
// import basket from "../../../Components/assets/icons/basket.png";
// import search1 from "../../../Components/assets/icons/search.png";
// import top from "../../../Components/assets/icons/top.png";
// import Table from "react-bootstrap/Table";
// import circle from "../../assets/icons/circle.png";
// import rigth from "../../assets/icons/rigth.png";
// import save from "../../assets/icons/save.png";
// import cancel from "../../assets/icons/cross.png";
// import { Link, useNavigate, useParams } from "react-router-dom";
// import Header from "../../Header/Header";

// import { library } from "@fortawesome/fontawesome-svg-core";
// import { fas } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// import Offcanvas from "react-bootstrap/Offcanvas";

// import toast, { Toaster } from "react-hot-toast";
// import Card from "react-bootstrap/Card";

// import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
// import { Context } from "../../../utils/context";

// import { IDS } from "../../../utils/common";

// import "../../Masters/datatable.css";
// import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
// import Pagination from "react-bootstrap/Pagination";
// import { putData } from "../../../utils/api";

// const EditOffCanvance = (props) => {
//   const { postData, getData, RequiredIs } = useContext(Context);

//   const id = props.show;
//   const [data, setData] = useState();

//   const [formData, setFormData] = useState({
//     role_id: "",
//     name: "",
//     permission_id: [],
//   });

//   const [permissions, setPermissions] = useState([]);
//   const [errors, setErrors] = useState({});
//   const [showModal, setShowModal] = useState(false);
//   const [showErrorModal, setShowErrorModal] = useState(false);
//   const [allChecked, setAllChecked] = useState([]);
//   const [selectedPermissions, setSelectedPermissions] = useState(false);

//   const validateForm = () => {
//     let errors = {};

//     const regex = /^[A-Za-z0-9]+(\s[A-Za-z0-9]+)*$/;

//     if (!formData?.name.trim()) {
//       errors.name = "Role Name is required";
//     } else if (!regex.test(formData?.name.trim())) {
//       errors.name = "Enter Valid Role ";
//     }

//     if (selectedPermissions?.length == 0) {
//       errors.permission_id = "Select Min 1 Permission is required";
//     }

//     return errors;
//   };

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target?.name]: e.target.value });
//   };

//   const handleSelectAll = async () => {
//     setSelectedPermissions(allChecked);
//     await setFormData({ ...formData, permission_id: allChecked });
//   };

//   const handleCheckboxChange = async (
//     permissionId,
//     value = null,
//     checked = null,
//   ) => {
//     if (value === "selectAll") {
//       if (checked) {
//         handleSelectAll();
//       } else {
//         await setFormData({ ...formData, permission_id: [] });
//         setSelectedPermissions([]);
//       }
//     } else {
//       const isSelected = selectedPermissions.includes(permissionId);

//       if (isSelected) {
//         const updatedSelectedPermissions = selectedPermissions.filter(
//           (id) => id !== permissionId,
//         );
//         setSelectedPermissions(updatedSelectedPermissions);
//         setFormData({ ...formData, permission_id: updatedSelectedPermissions });
//       } else {
//         const updatedSelectedPermissions = [
//           ...selectedPermissions,
//           permissionId,
//         ];
//         setSelectedPermissions(updatedSelectedPermissions);
//       }
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const validationErrors = validateForm();

//     if (Object.keys(validationErrors).length > 0) {
//       setErrors(validationErrors);
//     } else {
//       try {
//         formData.permission_id = selectedPermissions;

//         const response = await putData(
//           `/admin/employee-management/role/${id}`,
//           formData,
//         );

//         if (response.success) {
//           setShowModal(true);
//           setTimeout(() => {
//             setShowModal(false);
//             props.handleClose();
//           }, 1000);
//         } else {
//           setShowErrorModal(true);
//           setTimeout(() => {
//             setShowErrorModal(false);
//             props.handleClose();
//           }, 1000);
//         }
//       } catch (error) {
//         console.error("Error submitting form:", error);
//       }
//     }
//   };

//   const GetEditData = async () => {
//     const response = await getData(`/admin/employee-management/role/${id}`);
//     const roleData = response?.data;

//     // Check if response contains the Roles_Permissions array and map to get the permission_id
//     const selectedPermissionIds = Array.isArray(roleData?.Roles_Permissions)
//       ? roleData.Roles_Permissions.map((permission) => permission.permission_id) // or use `id` depending on your structure
//       : [];

//     // Set the full Roles_Permissions data if you want to keep it in state
//     setData(roleData?.Roles_Permissions);

//     // Store only the permission_ids in selectedPermissions
//     setSelectedPermissions(selectedPermissionIds);

//     // Store the full role data
//     setFormData(roleData);
//   };

//   useEffect(() => {
//     GetEditData();
//   }, []);

//   const getPermissions = async () => {
//     try {
//       const permissionResponse = await getData(
//         "/common/masters/all-permissions",
//       );
//       setPermissions(permissionResponse.data);
//       const newData = permissionResponse.data;
//       if (newData) {
//         const newIds = newData.map((d) => d?.id);
//         setAllChecked(newIds);
//       }
//     } catch (error) {
//       console.error("Error fetching permissions:", error);
//     }
//   };

//   useEffect(() => {
//     getPermissions();
//   }, []);

//   const errorStyle = {
//     color: "red",
//     marginLeft: "5px",
//   };

//   return (
//     <>
//       <Offcanvas
//         show={props.show}
//         style={{ width: "80%", height: "100%" }}
//         placement={"end"}
//         onHide={props.handleClose}
//       >
//         <Offcanvas.Header closeButton></Offcanvas.Header>
//         <Offcanvas.Body>
//           <div className="shadow-lg p-3 mb-5  rounded">
//             <Card.Body>
//               <Card.Title>Edit Role</Card.Title>
//               <hr />
//               <Row>
//                 <Col md={12}>
//                   <Row className="">
//                     <Col xxl={12} xl={12}>
//                       <Form onSubmit={handleSubmit} role="form">
//                         <Row>
//                           <Col lg={12} md={12} className=" mx-auto Add-content">
//                             <Row>
//                               <Col md={12}>
//                                 <div className="main-form-section ">
//                                   <Row className="">
//                                     <Col sm={6}>
//                                       <Form.Group>
//                                         <Form.Control
//                                           type="text"
//                                           name="name"
//                                           value={formData.name}
//                                           onChange={handleChange}
//                                           placeholder="Enter Role Name"
//                                           id="inputEmail3"
//                                         />
//                                         {errors.name && (
//                                           <span style={errorStyle}>
//                                             {errors.name}
//                                           </span>
//                                         )}
//                                       </Form.Group>
//                                     </Col>

//                                     <Col md={6}>
//                                       <div className="main-form-section ">
//                                         <Row className="">
//                                           <Form.Group>
//                                             <Form.Check
//                                               label=" Permissions Select All"
//                                               type="checkbox"
//                                               value="selectAll"
//                                               onChange={(e) =>
//                                                 handleCheckboxChange(
//                                                   e,
//                                                   "selectAll",
//                                                   e.target.checked,
//                                                 )
//                                               }
//                                             />
//                                             {errors.permission_id && (
//                                               <span style={errorStyle}>
//                                                 {errors.permission_id}
//                                               </span>
//                                             )}
//                                           </Form.Group>
//                                         </Row>
//                                       </div>
//                                     </Col>
//                                   </Row>
//                                 </div>
//                               </Col>

//                               <Col md={12}>
//                                 <div className="main-form-section allpermissionscroll mt-5">
//                                   <div className="row">
//                                     {Array.isArray(permissions) &&
//                                       permissions.map((data, index) => (
//                                         <div className="col-md-3" key={data.id}>
//                                           <Form.Group>
//                                             <Form.Check
//                                               type="checkbox"
//                                               label={data.name}
//                                               onChange={() =>
//                                                 handleCheckboxChange(data.id)
//                                               }
//                                               checked={
//                                                 selectedPermissions &&
//                                                 selectedPermissions?.includes(
//                                                   data?.id,
//                                                 )
//                                               }
//                                               id={`checkbox-${data.id}`}
//                                             />
//                                           </Form.Group>
//                                         </div>
//                                       ))}
//                                   </div>
//                                 </div>
//                               </Col>
//                             </Row>

//                             <Row className="mt-5 pb-3 cancelsavestic">
//                               <div className="d-flex justify-content-center">
//                                 <Button
//                                   type="button"
//                                   variant="danger"
//                                   onClick={() => props.handleClose()}
//                                   className="btn btn-cancel me-2"
//                                 >
//                                   <img
//                                     src={cancel}
//                                     className="cancel-img"
//                                     alt=""
//                                   />{" "}
//                                   Cancel
//                                 </Button>

//                                 <Button
//                                   variant="success"
//                                   type="submit"
//                                   onClick={handleSubmit}
//                                   className="btn btn-save"
//                                 >
//                                   <img
//                                     src={save}
//                                     className="save-img me-2"
//                                     alt=""
//                                   />{" "}
//                                   Save
//                                 </Button>
//                               </div>
//                             </Row>
//                           </Col>
//                         </Row>
//                       </Form>
//                     </Col>
//                   </Row>
//                 </Col>
//               </Row>
//             </Card.Body>
//           </div>
//         </Offcanvas.Body>
//       </Offcanvas>

//       {/* <!-- Modal --> */}
//       <div className="save-modal">
//         <div
//           className={`modal fade ${showModal ? "show" : ""}`}
//           style={{ display: showModal ? "block" : "none" }}
//           id="exampleModal1"
//           tabIndex="-1"
//           aria-labelledby="exampleModalLabel"
//           aria-hidden="true"
//         >
//           <div className="modal-dialog  modal-dialog-centered">
//             <div className="modal-content">
//               <div className="modal-body">
//                 <div className="circle justify-content-end">
//                   <img src={circle} className="circle-img mb-2" alt="" />
//                 </div>
//                 <h1 className="add-success text-center">
//                   Role Updated Successfully
//                 </h1>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* <!-- Modal --> */}
//       <div className="save-modal">
//         <div
//           className={`modal fade ${showErrorModal ? "show" : ""}`}
//           style={{ display: showErrorModal ? "block" : "none" }}
//           id="exampleModal1"
//           tabIndex="-1"
//           aria-labelledby="exampleModalLabel"
//           aria-hidden="true"
//         >
//           <div className="modal-dialog  modal-dialog-centered">
//             <div className="modal-content">
//               <div className="modal-body">
//                 <div className="circle justify-content-end">
//                   <img src={circle} className="circle-img mb-2" alt="" />
//                 </div>
//                 <h1 className="add-success text-center">Role Already Exits</h1>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default EditOffCanvance;

import React, { useContext, useEffect, useState } from "react";
import "../../Tabels/Tabels.css";

import circle from "../../assets/icons/circle.png";
import save from "../../assets/icons/save.png";
import cancel from "../../assets/icons/cross.png";

import Offcanvas from "react-bootstrap/Offcanvas";
import Card from "react-bootstrap/Card";
import Modal from "react-bootstrap/Modal";

import { Row, Col, Button, Form } from "react-bootstrap";

import { Context } from "../../../utils/context";
import "../../Masters/datatable.css";

import { putData } from "../../../utils/api";

const EditOffCanvance = (props) => {
  const { getData } = useContext(Context);

  const id = props.show;

  const [formData, setFormData] = useState({
    role_id: "",
    name: "",
    permission_id: [],
  });

  const [permissions, setPermissions] = useState([]);
  const [errors, setErrors] = useState({});

  // Always keep this as an array
  const [selectedPermissions, setSelectedPermissions] = useState([]);

  const [allChecked, setAllChecked] = useState([]);

  // Success / Error Modal
  const [showModal, setShowModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);

  // Loading state to prevent multiple clicks
  const [isSubmitting, setIsSubmitting] = useState(false);

  // ============================================
  // VALIDATE FORM
  // ============================================
  const validateForm = () => {
    const validationErrors = {};

    const regex = /^[A-Za-z0-9]+(\s[A-Za-z0-9]+)*$/;

    if (!formData?.name?.trim()) {
      validationErrors.name = "Role Name is required";
    } else if (!regex.test(formData.name.trim())) {
      validationErrors.name = "Enter Valid Role";
    }

    if (selectedPermissions.length === 0) {
      validationErrors.permission_id = "Select Min 1 Permission is required";
    }

    return validationErrors;
  };

  // ============================================
  // INPUT CHANGE
  // ============================================
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear name error when user starts typing
    if (name === "name") {
      setErrors((prev) => ({
        ...prev,
        name: "",
      }));
    }
  };

  // ============================================
  // SELECT ALL
  // ============================================
  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedPermissions(allChecked);

      setFormData((prev) => ({
        ...prev,
        permission_id: allChecked,
      }));
    } else {
      setSelectedPermissions([]);

      setFormData((prev) => ({
        ...prev,
        permission_id: [],
      }));
    }

    setErrors((prev) => ({
      ...prev,
      permission_id: "",
    }));
  };

  // ============================================
  // INDIVIDUAL CHECKBOX
  // ============================================
  const handleCheckboxChange = (permissionId, checked) => {
    setSelectedPermissions((prev) => {
      let updatedPermissions;

      if (checked) {
        updatedPermissions = [...prev, permissionId];
      } else {
        updatedPermissions = prev.filter((id) => id !== permissionId);
      }

      // Keep formData synchronized
      setFormData((formPrev) => ({
        ...formPrev,
        permission_id: updatedPermissions,
      }));

      return updatedPermissions;
    });

    setErrors((prev) => ({
      ...prev,
      permission_id: "",
    }));
  };

  // ============================================
  // SUBMIT FORM
  // ============================================
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    // Validate
    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      setIsSubmitting(true);

      // IMPORTANT:
      // Do not mutate formData directly.
      const submitData = {
        ...formData,
        permission_id: selectedPermissions,
      };

      const response = await putData(
        `/admin/employee-management/role/${id}`,
        submitData,
      );

      /*
        Supports:
        {
          success: true
        }

        OR:

        {
          data: {
            success: true
          }
      */
      const isSuccess =
        response?.success === true || response?.data?.success === true;

      if (isSuccess) {
        // ======================================
        // OPEN SUCCESS MODAL
        // ======================================
        setShowModal(true);

        setTimeout(() => {
          setShowModal(false);

          // Close Offcanvas
          props.handleClose();

          // Reset form
          setFormData({
            role_id: "",
            name: "",
            permission_id: [],
          });

          setSelectedPermissions([]);
          setErrors({});
        }, 1500);
      } else {
        // ======================================
        // OPEN ERROR MODAL
        // ======================================
        setShowErrorModal(true);
      }
    } catch (error) {
      console.error("Error submitting form:", error);

      setShowErrorModal(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  // ============================================
  // GET EDIT ROLE DATA
  // ============================================
  const GetEditData = async () => {
    if (!id) return;

    try {
      const response = await getData(`/admin/employee-management/role/${id}`);

      const roleData = response?.data;

      const selectedPermissionIds = Array.isArray(roleData?.Roles_Permissions)
        ? roleData.Roles_Permissions.map(
            (permission) => permission.permission_id,
          )
        : [];

      setSelectedPermissions(selectedPermissionIds);

      setFormData({
        ...roleData,
        permission_id: selectedPermissionIds,
      });
    } catch (error) {
      console.error("Error fetching role data:", error);
    }
  };

  // ============================================
  // GET ALL PERMISSIONS
  // ============================================
  const getPermissions = async () => {
    try {
      const permissionResponse = await getData(
        "/common/masters/all-permissions",
      );

      const permissionData = permissionResponse?.data || [];

      setPermissions(permissionData);

      const newIds = permissionData.map((item) => item?.id);

      setAllChecked(newIds);
    } catch (error) {
      console.error("Error fetching permissions:", error);
    }
  };

  // ============================================
  // LOAD DATA
  // ============================================
  useEffect(() => {
    GetEditData();
  }, [id]);

  useEffect(() => {
    getPermissions();
  }, []);

  // ============================================
  // SUCCESS MODAL CLOSE
  // ============================================
  const handleSuccessModalClose = () => {
    setShowModal(false);
    props.handleClose();
  };

  // ============================================
  // ERROR MODAL CLOSE
  // ============================================
  const handleErrorModalClose = () => {
    setShowErrorModal(false);
  };

  const errorStyle = {
    color: "red",
    marginLeft: "5px",
  };

  return (
    <>
      {/* ==================================================
          OFFCANVAS
      ================================================== */}
      <Offcanvas
        show={props.show}
        style={{
          width: "80%",
          height: "100%",
        }}
        placement="end"
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton />

        <Offcanvas.Body>
          <div className="shadow-lg p-3 mb-5 rounded">
            <Card.Body>
              <Card.Title>Edit Role</Card.Title>

              <hr />

              <Row>
                <Col md={12}>
                  <Row>
                    <Col xxl={12} xl={12}>
                      {/* IMPORTANT:
                          Only Form onSubmit handles submission.
                      */}
                      <Form onSubmit={handleSubmit}>
                        <Row>
                          <Col lg={12} md={12} className="mx-auto Add-content">
                            <Row>
                              {/* =================================
                                  ROLE NAME
                              ================================= */}
                              <Col md={12}>
                                <div className="main-form-section">
                                  <Row>
                                    <Col sm={6}>
                                      <Form.Group>
                                        <Form.Control
                                          type="text"
                                          name="name"
                                          value={formData.name || ""}
                                          onChange={handleChange}
                                          placeholder="Enter Role Name"
                                        />

                                        {errors.name && (
                                          <span style={errorStyle}>
                                            {errors.name}
                                          </span>
                                        )}
                                      </Form.Group>
                                    </Col>

                                    {/* =================================
                                        SELECT ALL
                                    ================================= */}
                                    <Col md={6}>
                                      <div className="main-form-section">
                                        <Row>
                                          <Form.Group>
                                            <Form.Check
                                              label="Permissions Select All"
                                              type="checkbox"
                                              checked={
                                                allChecked.length > 0 &&
                                                selectedPermissions.length ===
                                                  allChecked.length
                                              }
                                              onChange={(e) =>
                                                handleSelectAll(
                                                  e.target.checked,
                                                )
                                              }
                                            />

                                            {errors.permission_id && (
                                              <span style={errorStyle}>
                                                {errors.permission_id}
                                              </span>
                                            )}
                                          </Form.Group>
                                        </Row>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              </Col>

                              {/* =================================
                                  PERMISSIONS
                              ================================= */}
                              <Col md={12}>
                                <div className="main-form-section allpermissionscroll mt-4">
                                  <div className="row">
                                    {Array.isArray(permissions) &&
                                      permissions.map((data) => (
                                        <div className="col-md-3" key={data.id}>
                                          <Form.Group>
                                            <Form.Check
                                              type="checkbox"
                                              label={data.name}
                                              id={`checkbox-${data.id}`}
                                              checked={selectedPermissions.includes(
                                                data.id,
                                              )}
                                              onChange={(e) =>
                                                handleCheckboxChange(
                                                  data.id,
                                                  e.target.checked,
                                                )
                                              }
                                            />
                                          </Form.Group>
                                        </div>
                                      ))}
                                  </div>
                                </div>
                              </Col>
                            </Row>

                            {/* =================================
                                BUTTONS
                            ================================= */}
                            <Row className="mt-5 pb-3 cancelsavestic">
                              <div className="d-flex justify-content-center">
                                {/* CANCEL */}
                                <Button
                                  type="button"
                                  variant="danger"
                                  onClick={props.handleClose}
                                  className="btn btn-cancel me-2"
                                >
                                  <img
                                    src={cancel}
                                    className="cancel-img"
                                    alt="Cancel"
                                  />{" "}
                                  Cancel
                                </Button>

                                {/* SAVE */}
                                <Button
                                  variant="success"
                                  type="submit"
                                  className="btn btn-save"
                                  disabled={isSubmitting}
                                >
                                  <img
                                    src={save}
                                    className="save-img me-2"
                                    alt="Save"
                                  />

                                  {isSubmitting ? "Updating..." : "Save"}
                                </Button>
                              </div>
                            </Row>
                          </Col>
                        </Row>
                      </Form>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card.Body>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      {/* ==================================================
          SUCCESS MODAL
      ================================================== */}
      <Modal
        show={showModal}
        onHide={handleSuccessModalClose}
        centered
        backdrop="static"
        keyboard={false}
        className="save-modal"
      >
        <Modal.Body>
          <div className="circle d-flex justify-content-center">
            <img src={circle} className="circle-img mb-2" alt="Success" />
          </div>

          <h1 className="add-success text-center">Role Updated Successfully</h1>
        </Modal.Body>
      </Modal>

      {/* ==================================================
          ERROR MODAL
      ================================================== */}
      <Modal
        show={showErrorModal}
        onHide={handleErrorModalClose}
        centered
        className="save-modal"
      >
        <Modal.Body>
          <div className="circle d-flex justify-content-center">
            <img src={circle} className="circle-img mb-2" alt="Error" />
          </div>

          <h1 className="add-success text-center">Role Already Exists</h1>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default EditOffCanvance;
